<template>
  <div class="muven-switch__container">
    <input :id="idSwitch" class="muven-switch muven-switch--shadow" type="checkbox" v-model="propCheckMutable" />
    <label :for="idSwitch"></label>
    <span class="muven-switch-descricao" v-show="propCheckMutable">{{ labelChecked }}</span>
    <span class="muven-switch-descricao" v-show="!propCheckMutable">{{ labelUnchecked }}</span>
  </div>
</template>

<script>
import { v1 as uuidv1 } from 'uuid' // random

export default {
  props: {
    propCheck: {
      type: Boolean,
      default: false,
    },
    labelChecked: {
      type: String,
      default: "",
    },
    labelUnchecked: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      idSwitch: `muven-switch-id-${uuidv1()}`,
      propCheckMutable: this.propCheck,
    }
  },
  watch: {
    propCheck(val) {
      this.propCheckMutable = val
    },
    propCheckMutable() {
      this.$emit('updated', this.propCheckMutable)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.muven-switch__container {
  position: relative;
  margin-top: 15px;
  margin-bottom: 15px;
  min-height: 25px;

  .muven-switch {
    visibility: hidden;
    position: absolute;
    margin-left: -9999px;
  }

  .muven-switch+label {
    display: block;
    position: relative;
    cursor: pointer;
    outline: none;
    user-select: none;
  }

  .muven-switch--shadow+label {
    position: absolute;
    right: 0;
    padding: 2px;
    width: 45px;
    height: 25px;
    background-color: var(--border);
    border-radius: 60px;
  }

  .muven-switch--shadow+label:before,
  .muven-switch--shadow+label:after {
    content: "";
    display: block;
    position: absolute;
    top: 1px;
    left: 1px;
    bottom: 1px;
  }

  .muven-switch--shadow+label:before {
    right: 1px;
    background-color: var(--surface-3);
    border-radius: 60px;
    transition: background 0.4s;
  }

  .muven-switch--shadow+label:after {
    width: 25px;
    background-color: var(--white);
    border-radius: 100%;
    box-shadow: 0 2px 5px color-mix(in srgb, var(--shadow-ink) 30%, transparent);
    transition: all 0.4s;
  }

  .muven-switch--shadow:checked+label:before {
    background-color: var(--brand-fill);
  }

  .muven-switch--shadow:checked+label:after {
    transform: translateX(18px);
  }

  .muven-switch-descricao {
    position: absolute;
    top: 0;
  }
}
</style>
